module.exports = "/_next/static/images/num-0-1ac538b8.png";